import SegmentWrapper from '../segmentWrapper'

function sendEvent(event, properties) {
  SegmentWrapper.track(event, properties)
}

export default {
  sendEvent
}
